import { z } from 'zod';
/** Anotación privada del director sobre un posible alumno (1..2000 chars). */
export const createProspectNoteSchema = z.object({
    note: z
        .string()
        .trim()
        .min(1, 'La anotación no puede estar vacía')
        .max(2000, 'Máximo 2000 caracteres'),
});
//# sourceMappingURL=prospect-note.schema.js.map